import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import defaultStyle from './modal-window.style';
import './common.scss';
import './modal-window.scss';

export class ModalWindow extends Component {

  render() {
    const { show, onClose, title, footer, children, css, contentId, modalId } = this.props;

    return(
      <div tabIndex={-1} id={modalId || "modal"}>
        <div className={show ? css.show : css.hide}>
          <div className={css.dialog}>
            <div className={css.content}>
              <div className={css.header}>
                <button type="button" className={css.closeButton} onClick={e => onClose(e)}>
                  <span aria-label="close">&times;</span>
                </button>
                <h4 className={css.title}>
                  {title}
                </h4>
              </div>
              <div tabIndex={-1} id={contentId || "modal-content"} className={css.body + " no-focus"}>
                {children}
              </div>
              <div className={css.footer}>
                {footer}
              </div>
            </div>
          </div>
        </div>
        <div className={show ? css.backgroundShow : css.backgroundHide} />
      </div>
    );
  }
}

ModalWindow.propTypes = {
  modalId: PropTypes.string,
  contentId: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.any.isRequired,
  footer: PropTypes.element
};

export default styleable(defaultStyle) (ModalWindow);
